import { motion } from "framer-motion";
import { CountUp } from "../site/CountUp";
import { STATS } from "@/data/content";
import { useSiteContent } from "@/context/SiteContentContext";
import { staggerContainer, staggerItem } from "../site/Reveal";

export const Stats = () => {
  const { home } = useSiteContent();
  const stats = home.stats?.length ? home.stats : STATS;
  return (
    <section data-testid="stats-section" className="bg-aero-deep">
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
        <div className="mb-14 max-w-2xl">
          <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
            By The Numbers
          </span>
          <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-ink sm:text-5xl">
            Five decades, measured in trust.
          </h2>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-steel/20 bg-steel/20 md:grid-cols-3"
        >
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              variants={staggerItem}
              data-testid={`stat-card-${i}`}
              className="group bg-aero-surface p-8 transition-colors duration-500 hover:bg-aero-navy sm:p-10"
            >
              <div className="font-heading text-4xl font-black tracking-tight text-ink sm:text-5xl">
                <span className="text-saffron">
                  <CountUp
                    value={stat.value}
                    decimals={stat.decimals || 0}
                    prefix={stat.prefix}
                    suffix={stat.suffix}
                  />
                </span>
              </div>
              <p className="mt-3 font-body text-sm leading-relaxed text-steel">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
